"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowUp = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var ArrowUp = function ArrowUp() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.1513 9.54981C19.8832 9.81671 19.5195 9.96665 19.1404 9.96665C18.7612 9.96665 18.3975 9.81671 18.1294 9.54981L13.4206 4.8616V22.5763C13.4206 22.9539 13.2699 23.316 13.0018 23.583C12.7336 23.85 12.3699 24 11.9906 24C11.6114 24 11.2477 23.85 10.9795 23.583C10.7114 23.316 10.5607 22.9539 10.5607 22.5763V4.8616L5.85191 9.54981C5.58222 9.80915 5.22101 9.95265 4.84609 9.94941C4.47116 9.94616 4.11251 9.79644 3.84739 9.53247C3.58227 9.26851 3.43188 8.91143 3.42863 8.53814C3.42537 8.16486 3.5695 7.80523 3.82997 7.53671L10.9797 0.418262C11.1125 0.285678 11.2703 0.180491 11.444 0.108719C11.6178 0.0369463 11.804 -2.38419e-07 11.9921 -2.38419e-07C12.1802 -2.38419e-07 12.3664 0.0369463 12.5401 0.108719C12.7139 0.180491 12.8716 0.285678 13.0045 0.418262L20.1542 7.53671C20.4219 7.80407 20.572 8.16634 20.5714 8.54385C20.5709 8.92137 20.4198 9.28321 20.1513 9.54981Z"
    })
  });
};
exports.ArrowUp = ArrowUp;